import { useRef, useState, useEffect } from "react";
import { useTranslation, Trans } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import b1 from "../../img/Home/back.svg";
import b2 from "../../img/Home/next.svg";

import sw1 from '../../img/Accounts/a1.svg';
import sw2 from '../../img/Accounts/a2.svg';
import sw3 from '../../img/Accounts/a3.svg';
import sw4 from '../../img/Accounts/a4.svg';
import sw5 from '../../img/Accounts/a5.svg';

import no from '../../img/Accounts/no.svg';
import yes from '../../img/Accounts/yes.svg';
import yes2 from '../../img/Accounts/yes2.svg'

import Button from '../Button'

const data = [
  {
    img: sw1,
    title: "Access 250",
    minDeposit: "250 USD",
    accountCurrency: "USD",
    leverage: "Forex",
    spread: "-",
    commission: "-",
    swapFree: "+",
    maxOrders: "+",
    marginCall: "1-2%",
    bg: '#2A2A3D',
  },
  {
    img: sw2,
    title: "Privilege 1500",
    minDeposit: "1500 USD",
    accountCurrency: "USD",
    leverage: "Forex, Commodity",
    spread: "-",
    commission: "+",
    swapFree: "+",
    maxOrders: "+",
    marginCall: "1%",
    bg: '#4A4A65',
  },
  {
    img: sw3,
    title: "Excellency 10000",
    minDeposit: "10000 USD",
    accountCurrency: "USD",
    leverage: "Forex, Commodity, Stocks, Cryptocurrency",
    spread: "+",
    commission: "+",
    swapFree: "+",
    maxOrders: "+",
    marginCall: "0.5%",
    bg: '#2045FE',
  },
];

function Various() {

  const { t } = useTranslation();
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const paginationRef = useRef(null);
  const [swiperInstance, setSwiperInstance] = useState(null);

  useEffect(() => {
    if (swiperInstance && prevRef.current && nextRef.current && paginationRef.current) {
      swiperInstance.params.navigation.prevEl = prevRef.current;
      swiperInstance.params.navigation.nextEl = nextRef.current;
      swiperInstance.navigation.init();
      swiperInstance.navigation.update();

      swiperInstance.params.pagination.el = paginationRef.current;
      swiperInstance.pagination.init();
      swiperInstance.pagination.update();
    }
  }, [swiperInstance]);

  return (
    <div className="relative pt-[80px] xl:pt-[160px] overflow-hidden">
        <div className="max-w-[1220px] mx-[20px] xl:mx-auto">
            <div className="flex flex-col md:flex-row justify-between">
                <p className="zen-dots leading-[1.2] text-[24px] xl:text-[36px] text-[#fff]">
                    <Trans>{t("main.32")}</Trans>
                </p>
                <p className="xl:max-w-[393px] text-[#FFFFFFB2] text-[14px] ibm-plex mt-[20px] xl:mt-0">
                    {t("main.33")}
                </p>
            </div>
            <div className="flex flex-col xl:flex-row justify-between mt-[40px] xl:mt-[80px]">
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            loop={false}
            autoplay={{ delay: 3000 }}
            navigation={{
              prevEl: '.custom-prev',
              nextEl: '.custom-next',
            }}
            pagination={{
              el: '.custom-pagination',
              clickable: true,
            }}
            className="w-full h-full"
            spaceBetween={20}
            breakpoints={{
              0: {
                slidesPerView: 1, // телефон
              },
              640: {
                slidesPerView: 2, // планшет
              },
              1220: {
                slidesPerView: 3, // ПК
              },
            }}
          >
            {data.map((item, index) => (
              <SwiperSlide key={index}>
                <div className={`h-[620px] py-[20px] px-[20px] xl:pl-[40px] flex flex-col`} style={{background: item.bg}}>
                    <div className="flex items-center gap-[10px] xl:gap-[30px]">
                      <div style={{background: '#FFFFFF'}} className="w-[60px] h-[60px] flex items-center justify-center">
                        <img src={item.img} alt="" className="w-[22px] h-[22px]"/>
                      </div>
                      <h2 className="zen-dots text-[16px] xl:text-[24px] mt-[5px]" style={{color: '#FFFFFF'}}>{t(item.title)}</h2>
                    </div>
                    <div className="grid grid-cols-2 mt-[25px] gap-y-[8px]">
                      <p className="ibm-plex text-[14px]" style={{color: index === 2 ? '#FFFFFFB2' : '#FFFFFFB2'}}>{t('account.7')}</p>
                      <p className="ibm-plex text-[14px] font-[500]" style={{color: index === 2 ? '#FFFFFFB2' : '#FFFFFFB2'}}>{data[index].minDeposit}</p>
                      <p className="ibm-plex text-[14px]" style={{color: index === 2 ? '#FFFFFFB2' : '#FFFFFFB2'}}>{t('account.8')}</p>
                      <p className="ibm-plex text-[14px] font-[500]" style={{color: index === 2 ? '#FFFFFFB2' : '#FFFFFFB2'}}>{data[index].accountCurrency}</p>
                      <p className="ibm-plex text-[14px]" style={{color: index === 2 ? '#FFFFFFB2' : '#FFFFFFB2'}}>{t('account.9')}</p>
                      <p className="ibm-plex text-[14px] font-[500]" style={{color: index === 2 ? '#FFFFFFB2' : '#FFFFFFB2'}}>{data[index].leverage}</p>
                      <p className="ibm-plex text-[14px]" style={{color: index === 2 ? '#FFFFFFB2' : '#FFFFFFB2'}}>{t('account.10')}</p>
                      <p className="ibm-plex text-[14px] font-[500]" style={{ color: index === 2 ? '#FFFFFFB2' : '#FFFFFFB2' }}>
                        {data[index].spread === '-' ? (
                          <img src={no} alt="No" className="w-4 h-4 inline-block" />
                        ) : data[index].spread === '+' ? (
                          <img src={index === 2 ? yes2 : yes} alt="Yes" className="w-4 h-4 inline-block" />
                        ) : (
                          data[index].commission
                        )}
                      </p>
                      <p className="ibm-plex text-[14px]" style={{ color: index === 2 ? '#FFFFFFB2' : '#FFFFFFB2' }}>
                        {t('account.11')}
                      </p>
                      <p className="ibm-plex text-[14px] font-[500]" style={{ color: index === 2 ? '#FFFFFFB2' : '#FFFFFFB2' }}>
                        {data[index].commission === '-' ? (
                          <img src={no} alt="No" className="w-4 h-4 inline-block" />
                        ) : data[index].commission === '+' ? (
                          <img src={index === 2 ? yes2 : yes} alt="Yes" className="w-4 h-4 inline-block" />
                        ) : (
                          data[index].commission
                        )}
                      </p>
                      <p className="ibm-plex text-[14px]" style={{ color: index === 2 ? '#FFFFFFB2' : '#FFFFFFB2' }}>
                        {t('account.12')}
                      </p>
                      <p className="ibm-plex text-[14px] font-[500]" style={{ color: index === 2 ? '#FFFFFFB2' : '#FFFFFFB2' }}>
                        {data[index].swapFree === '-' ? (
                          <img src={no} alt="No" className="w-4 h-4 inline-block" />
                        ) : data[index].swapFree === '+' ? (
                          <img src={index === 2 ? yes2 : yes} alt="Yes" className="w-4 h-4 inline-block" />
                        ) : (
                          data[index].swapFree
                        )}
                      </p>
                      <p className="ibm-plex text-[14px]" style={{color: index === 2 ? '#FFFFFFB2' : '#FFFFFFB2'}}>{t('account.13')}</p>
                      <p className="ibm-plex text-[14px] font-[500]" style={{ color: index === 2 ? '#FFFFFFB2' : '#FFFFFFB2' }}>
                        {data[index].maxOrders === '-' ? (
                          <img src={no} alt="No" className="w-4 h-4 inline-block" />
                        ) : data[index].maxOrders === '+' ? (
                          <img src={index === 2 ? yes2 : yes} alt="Yes" className="w-4 h-4 inline-block" />
                        ) : (
                          data[index].commission
                        )}
                      </p>
                      <p className="ibm-plex text-[14px]" style={{color: index === 2 ? '#FFFFFFB2' : '#FFFFFFB2'}}>{t('account.14')}</p>
                      <p className="ibm-plex text-[14px] font-[500]" style={{color: index === 2 ? '#FFFFFFB2' : '#FFFFFFB2'}}>{data[index].marginCall}</p>
                      {index === 3 && (
                        <>
                          <p
                            className="ibm-plex text-[14px]"
                            style={{ color: index === 2 ? '#FFFFFFB2' : '#FFFFFFB2' }}
                          >
                            {t('account.19')}
                          </p>
                          <p
                            className="ibm-plex text-[14px] font-[500]"
                            style={{ color: index === 2 ? '#FFFFFFB2' : '#FFFFFFB2' }}
                          >
                            {data[index].execution}
                          </p>
                        </>
                      )}
                    </div>
                    
                </div>  
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <div className="flex flex-col-reverse xl:flex-row justify-between mt-[10px] xl:mt-0 w-full md:w-auto">
          <div className="flex items-center justify-between border-[#00000033] h-[48px] md:w-auto w-full">
            <div className="flex md:w-auto w-full">
                <button ref={prevRef} className="w-full custom-prev md:w-[124px] border-l border-t bg-white border-b hover:border hover:border-black transition-all h-[48px] border-[#00000033] flex items-center justify-center cursor-my"><img src={b1} alt="" /></button>
                <button ref={nextRef} className="w-full custom-next md:w-[124px] border bg-white hover:border hover:border-black transition-all h-[48px] border-[#00000033] flex items-center justify-center cursor-my"><img src={b2} alt="" /></button>
            </div>
          </div>
        </div>
        <div className="bg-white xl:h-[428px] w-full xl:mt-[-30px] py-[20px] px-[20px] xl:px-[40px] mt-[10px]">
          <div className="flex items-center gap-[10px] xl:gap-[30px]">
            <div className="w-[60px] h-[60px] bg-[#1E1C21] flex items-center justify-center">
              <img src={sw4} alt="" className="w-[22px] h-[22px]"/>
            </div>
            <h2 className="zen-dots text-[16px] xl:text-[24px] mt-[5px] text-[#000]">Islamic Account</h2>
          </div>
          <div className="flex flex-col md:flex-row justify-between gap-[20px] mt-[15px] xl:mt-[25px]">
            <div>
              <div className="grid grid-cols-2 gap-x-[30px] gap-y-[8px]">
                <p className="ibm-plex text-[14px] text-[#000000B2]">{t('account.7')}</p>
                <p className="ibm-plex text-[14px] font-[500] text-[#000000B2]">1000 USD</p>
                <p className="ibm-plex text-[14px] text-[#000000B2]">{t('account.8')}</p>
                <p className="ibm-plex text-[14px] font-[500] text-[#000000B2]">USD</p>
                <p className="ibm-plex text-[14px] text-[#000000B2]">{t('account.14')}</p>
                <p className="ibm-plex text-[14px] font-[500] text-[#000000B2]">From 0.8%</p>
              </div>
              <div className="flex gap-[8px] xl:gap-[16px] items-center mt-[20px] xl:mt-[40px]">
                <div className="w-[4px] h-[4px] bg-[#1E1C21] flex-shrink-0"></div>
                <p className="ibm-plex text-[14px] text-[#000000B2]">{t('acc.1')}</p>
              </div>
              <p className="max-w-[550px] font-[500] text-[14px] ibm-plex text-[#000000B2] mt-[5px]">{t('acc.2')}</p>
              <div className="flex gap-[8px] xl:gap-[16px] items-center mt-[20px]">
                <div className="w-[4px] h-[4px] bg-[#1E1C21] flex-shrink-0"></div>
                <p className="ibm-plex text-[14px] text-[#000000B2]">{t('acc.3')}</p>
              </div>
              <p className="max-w-[550px] font-[500] text-[14px] ibm-plex text-[#000000B2] mt-[5px]">{t('acc.3.3')}</p>
            </div> 
            <div className="mt-[20px] xl:mt-0">
              <div className="flex gap-[8px] xl:gap-[16px] items-center">
                <div className="w-[4px] h-[4px] bg-[#1E1C21] flex-shrink-0"></div>
                <p className="ibm-plex text-[14px] text-[#000000B2]">{t('acc.4')}</p>
              </div>
              <p className="max-w-[550px] font-[500] text-[14px] ibm-plex text-[#000000B2] mt-[5px]">{t('acc.5')}</p>
              <div className="flex gap-[8px] xl:gap-[16px] items-center mt-[20px]">
                <div className="w-[4px] h-[4px] bg-[#1E1C21] flex-shrink-0"></div>
                <p className="ibm-plex text-[14px] text-[#000000B2]">{t('acc.6')}</p>
              </div>
              <p className="max-w-[550px] font-[500] text-[14px] ibm-plex text-[#000000B2] mt-[5px]">{t('acc.7')}</p>
              <div className="flex gap-[8px] xl:gap-[16px] items-center mt-[20px]">
                <div className="w-[4px] h-[4px] bg-[#1E1C21] flex-shrink-0"></div>
                <p className="ibm-plex text-[14px] text-[#000000B2]">{t('acc.10')}</p>
              </div>
              <p className="max-w-[550px] font-[500] text-[14px] ibm-plex text-[#000000B2] mt-[5px]">{t('acc.11')}</p>
            </div>
          </div>
        </div>
        <div className="bg-[#2A2A3D] w-full xl:mt-[20px] mt-[10px] py-[24px] xl:py-[30px] px-[20px] xl:px-[40px] text-white">
          {/* TOP: Header + 2 columns */}
          <div className="grid xl:grid-cols-2 gap-[24px] xl:gap-[40px]">
            {/* LEFT */}
            <div>
              <div className="flex items-center gap-[10px] xl:gap-[20px]">
                <div className="w-[52px] h-[52px] xl:w-[60px] xl:h-[60px] bg-white flex items-center justify-center">
                  <img src={sw5} alt="" className="w-[22px] h-[22px]" />
                </div>
                <h2 className="zen-dots text-[16px] xl:text-[24px] tracking-wide">
                  {t("vip.1")}
                </h2>
              </div>

              <p className="ibm-plex text-[12px] xl:text-[14px] text-white/70 mt-[14px] xl:mt-[18px] max-w-[520px] leading-[1.55]">
                {t("vip.2")}
              </p>

              {/* account rows like on screen */}
              <div className="mt-[16px] xl:mt-[18px] space-y-[8px] xl:space-y-[10px] max-w-[520px]">
                <div className="flex items-baseline justify-between gap-[20px]">
                  <span className="ibm-plex text-[12px] xl:text-[13px] text-white/60">{t("vip.3")}</span>
                  <span className="ibm-plex text-[12px] xl:text-[13px] text-white/85 font-[500]">{t("vip.4")}</span>
                </div>
                <div className="flex items-baseline justify-between gap-[20px]">
                  <span className="ibm-plex text-[12px] xl:text-[13px] text-white/60">{t("vip.5")}</span>
                  <span className="ibm-plex text-[12px] xl:text-[13px] text-white/85 font-[500]">{t("vip.6")}</span>
                </div>
                <div className="flex items-baseline justify-between gap-[20px]">
                  <span className="ibm-plex text-[12px] xl:text-[13px] text-white/60">{t("vip.7")}</span>
                  <span className="ibm-plex text-[12px] xl:text-[13px] text-white/85 font-[500] text-right">
                    {t("vip.8")}
                  </span>
                </div>
              </div>
            </div>

            {/* RIGHT */}
            <div className="xl:pl-[10px]">
              <h3 className="zen-dots text-[14px] xl:text-[16px] tracking-wide">
                {t("vip.9")}
              </h3>

              <ul className="mt-[12px] xl:mt-[16px] space-y-[10px]">
                {[10, 11, 12, 13, 14, 15, 16].map((i) => (
                  <li key={i} className="flex gap-[10px]">
                    <span className="w-[4px] h-[4px] bg-white/90 mt-[8px] flex-shrink-0" />
                    <span className="ibm-plex text-[12px] xl:text-[13px] text-white/75 leading-[1.45]">
                      {t(`vip.${i}`)}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Key Advantage */}
          <div className="mt-[26px] xl:mt-[34px]">
            <h3 className="zen-dots text-[14px] xl:text-[16px] tracking-wide">
              {t("vip.17")}
            </h3>

            {/* 6 blocks in 3 columns like on screen */}
            <div className="mt-[14px] xl:mt-[18px] grid md:grid-cols-2 xl:grid-cols-3 gap-[18px] xl:gap-[26px]">
              {[
                ["vip.18", "vip.19"],
                ["vip.20", "vip.21"],
                ["vip.22", "vip.23"],
                ["vip.24", "vip.25"],
                ["vip.26", "vip.27"],
                ["vip.28", "vip.29"]
              ].map(([title, desc], idx) => (
                <div key={idx}>
                  <div className="flex gap-[10px] items-start">
                    <span className="w-[4px] h-[4px] bg-white/90 mt-[8px] flex-shrink-0" />
                    <p className="ibm-plex text-[12px] xl:text-[13px] text-white/85 font-[500] leading-[1.4]">
                      {t(title)}
                    </p>
                  </div>
                  <p className="ibm-plex text-[12px] xl:text-[13px] text-white/60 leading-[1.55] mt-[6px] ml-[14px] max-w-[360px]">
                    {t(desc)}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Bottom 2 columns: Exclusive Feature + Conditions */}
          <div className="mt-[26px] xl:mt-[34px] grid xl:grid-cols-2 gap-[24px] xl:gap-[40px]">
            {/* Exclusive Feature */}
            <div>
              <h3 className="zen-dots text-[14px] xl:text-[16px] tracking-wide">
                {t("vip.30")}
              </h3>

              <p className="ibm-plex text-[12px] xl:text-[13px] text-white/70 leading-[1.55] mt-[12px] max-w-[560px]">
                {t("vip.31")}
              </p>

              <p className="ibm-plex text-[12px] xl:text-[13px] text-white/75 font-[500] mt-[14px]">
                {t("vip.32")}
              </p>

              <ul className="mt-[10px] space-y-[10px]">
                {[33, 34, 35, 36, 37].map((i) => (
                  <li key={i} className="flex gap-[10px]">
                    <span className="w-[4px] h-[4px] bg-white/90 mt-[8px] flex-shrink-0" />
                    <span className="ibm-plex text-[12px] xl:text-[13px] text-white/65 leading-[1.5]">
                      {t(`vip.${i}`)}
                    </span>
                  </li>
                ))}
              </ul>

              <p className="ibm-plex text-[12px] xl:text-[13px] text-white/60 leading-[1.55] mt-[14px] max-w-[560px]">
                {t("vip.38")}
              </p>
            </div>

            {/* Conditions (Key Benefits on the screen right bottom) */}
            <div className="xl:pl-[10px]">
              <h3 className="zen-dots text-[14px] xl:text-[16px] tracking-wide">
                {t("vip.39")}
              </h3>

              <div className="mt-[14px] space-y-[10px] max-w-[420px]">
                {[
                  ["vip.40", "vip.41"],
                  ["vip.42", "vip.43"],
                  ["vip.44", "vip.45"],
                  ["vip.46", "vip.47"],
                  ["vip.48", "vip.49"]
                ].map(([k, v], idx) => (
                  <div key={idx} className="flex items-baseline justify-between gap-[20px]">
                    <span className="ibm-plex text-[12px] xl:text-[13px] text-white/60">
                      {t(k)}
                    </span>
                    <span className="ibm-plex text-[12px] xl:text-[13px] text-white/85 font-[500]">
                      {t(v)}
                    </span>
                  </div>
                ))}
              </div>
              <div className="mt-[28px] xl:mt-[36px]">
                <h3 className="zen-dots text-[14px] xl:text-[16px] tracking-wide">
                  {t("vip.50")}
                </h3>
                <p className="ibm-plex text-[12px] xl:text-[13px] text-white/65 mt-[10px] max-w-[520px] leading-[1.55]">
                  {t("vip.51")}
                </p>
              </div>
            </div>
          </div>
        </div>
        </div>
    </div>
  );
}

export default Various;
